var React = require('react');

function LiveChat (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M18 0H2a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM4 7h12v2H4V7zm8 5H4v-2h8v2zm4-6H4V4h12v2z"}));
}

LiveChat.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = LiveChat;

LiveChat.default = LiveChat;
